/** A wash of the current sky color down the top of the page. Decorative only. */
export function SkyBackground({ color }: { color: string | null }) {
  if (!color) return null;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 -z-10 h-[60vh] print:hidden"
      style={{
        background: `linear-gradient(to bottom, color-mix(in oklab, ${color} 34%, transparent), color-mix(in oklab, ${color} 8%, transparent) 55%, transparent)`,
      }}
    />
  );
}
